import React from 'react';
import PropTypes from 'prop-types';
import { useDictionary } from '../../../../utilities/hooks/UseDictionary';

const DurationFields = ({
	days,
	hours,
	minutes,
	setDays,
	setHours,
	setMinutes,
	style,
	inputTestIdPrefix = 'duration'
}) => {
	const dictionary = useDictionary();

	return (
		<div
			className="group-inputs"
			style={{
				display: 'flex',
				justifyContent: 'space-between',
				marginTop: 0,
				marginBottom: 16,
				...style
			}}
		>
			<div className="duration-input-container">
				<input
					className="duration-input"
					type="number"
					min="0"
					step="1"
					value={days}
					onChange={(event) => setDays(event.target.value)}
					data-testid={`${inputTestIdPrefix}-days-input`}
				/>
				<div className="duration-input-label">{dictionary.days_dialog}</div>
			</div>
			<div className="duration-input-container">
				<input
					className="duration-input"
					type="number"
					min="0"
					step="1"
					value={hours}
					onChange={(event) => setHours(event.target.value)}
					data-testid={`${inputTestIdPrefix}-hours-input`}
				/>
				<div className="duration-input-label">{dictionary.hours_dialog}</div>
			</div>
			<div className="duration-input-container">
				<input
					className="duration-input"
					type="number"
					min="0"
					step="1"
					value={minutes}
					onChange={(event) => setMinutes(event.target.value)}
					data-testid={`${inputTestIdPrefix}-minutes-input`}
				/>
				<div className="duration-input-label">{dictionary.minutes_dialog}</div>
			</div>
		</div>
	);
};

DurationFields.propTypes = {
	days: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
	hours: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
	minutes: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
	setDays: PropTypes.func.isRequired,
	setHours: PropTypes.func.isRequired,
	setMinutes: PropTypes.func.isRequired,
	style: PropTypes.object,
	inputTestIdPrefix: PropTypes.string
};

export default DurationFields;
